import { isEmpty } from 'ramda'


const base = 'js-unique-prefix'
let _id = 0

export const generateId = () => {
    const id = `${base}-${_id}`
    _id += 1

    return id
}

/**
 * Component that generates a unique id and passes it down to its slot.
 *
 * @example
 *
 * <unique-id v-slot="{ id }">
 *    <label :for="id">Label</label>
 *    <input :id="id" type="text" name="foo" />
 * </unique-id>
 */
export default {
    props: {
        /**
         * Only renders a surrounding tag if a `tagName` prop is specified.
         */
        tagName: { type: String, default: '' },
    },

    inheritAttrs: true,

    data: () => ({ id: generateId() }),

    mounted () {
        /**
         * Regenerate the id in order to avoid incorrect update during
         * client side hydration
         * - sometimes nuxt updates the id on the client, but only
         *   updates part of the DOM :/
         */
        this.id = generateId()
    },

    render (h) {
        return isEmpty(this.tagName)
            ? this.$scopedSlots.default({ id: this.id })
            : h(this.tagName, this.$scopedSlots.default({ id: this.id }))
    },
}
